import React from "react";
import { StyleSheet, View } from "react-native";

import { DEFAULT_PAGE_WIDTH } from "@towersystems/roam-common-native";

export interface StockCountFooterModalProps {
  onCompact?: () => void;
  onPreview?: () => void;
  onFullscreen?: () => void;
  children?: React.ReactNode;
}

export function StockCountFooterModal({
  children,
}: StockCountFooterModalProps) {
  return (
    <View
      style={{
        position: "absolute",
        bottom: 0,
        width: "100%",
        zIndex: 100,
      }}
    >
      <View
        style={{
          ...styles["content__modal"],
          maxWidth: DEFAULT_PAGE_WIDTH,
          width: "100%",
          margin: "auto",
        }}
      >
        {children}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content__modal: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.45,
    shadowRadius: 16,
    backgroundColor: "white",
    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
  },
});
